import React from 'react';
import { Grid, Divider, Card, Segment } from 'semantic-ui-react';
import withDataFetch from '../../api/withDataFetch';
import withFullScreenLoading from '../UtilityComponents/withFullScreenLoading/index';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import './Questions.css';
import QuestionForm from './QuestionForm';

const Questions = ({ data: { title, questions } }) => {
  return (
    <Grid stackable className="Questions">
      <Grid.Row centered columns="equal">
        <h2 className="Page__Title">
          {renderDataAsPlainText(title)}
        </h2>
      </Grid.Row>
      <Divider />
      <Grid.Row className="Questions__List" as={Segment}>
        {questions.map(({ question, answer }) => {
          return (
            <Card fluid className="Questions__List__Card">
              <Card.Content>
                <Card.Header>
                  {renderDataAsHtml(question)}
                </Card.Header>
                <Card.Description>
                  {renderDataAsHtml(answer)}
                </Card.Description>
              </Card.Content>
            </Card>
          );
        })}
      </Grid.Row>
      <Divider />
      <QuestionForm />
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoading(Questions), 'questions');



// WEBPACK FOOTER //
// ./src/components/Questions/index.js